import {Component, OnInit} from '@angular/core';
import {AsyncPipe, NgClass, NgForOf, NgIf} from "@angular/common";
import {BaseSectionComponent} from "../base-section/base-section.component";
import {TinyPostComponent} from "../../elements/tiny-post/tiny-post.component";
import {TinyPostsFromIdsPipe} from "../../../pipes/tinyPostFromId/tiny-post-from-id.pipe";
import {PageListPagesSection} from "../../../models/Page/Sections/PageListPagesSection";
import {PageBaseSection} from "../../../models/Page/PageBaseSection";
import {SynapiListItemsComponent} from "../../elements/synapi-list-items/synapi-list-items.component";
import {SynapiPredicate} from "../../../models/Synapi/SynapiPredicate";
import {BookmarksService} from "../../../services/bookmarks.service";
import {SynapiService} from "../../../services/synapi.service";
import {Bookmarks} from "../../../models/Misc/Bookmarks";
import {Router} from "@angular/router";

@Component({
  selector: 'bookmarks-section',
  standalone: true,
  imports: [
    AsyncPipe,
    BaseSectionComponent,
    NgForOf,
    NgIf,
    TinyPostComponent,
    TinyPostsFromIdsPipe,
    SynapiListItemsComponent,
    NgClass
  ],
  templateUrl: './bookmarks-section.component.html',
  styleUrl: './bookmarks-section.component.scss'
})
export class BookmarksSectionComponent extends BaseSectionComponent<PageBaseSection> implements OnInit{

  public bookmarks: Bookmarks = new Bookmarks();
  public total = 0;
  public displayAll = true;
  public displayActivities = false;
  public displayRestaurants = false;
  public displayAccommodations = false;
  public displayEvents = false;
  public displayStays = false;
  public displayOthers = false;
  public displayServices = false;
  public linkCopied = false;
  constructor(public bookmarksService: BookmarksService, public synapi: SynapiService,private router: Router) {
    super();
    this.bookmarksService.bookmarks$.subscribe(()=>{
      this.bookmarks = this.bookmarksService.bookmarks;
      this.total = this.bookmarksService.extractIds().length;
    })
  }

  onPdfClick(){
    this.bookmarksService.pdf();
  }

  onRemoveAllClick(){
    if(window.confirm("Souhaitez-vous vraiment supprimer tous vos favoris ?")){
      this.bookmarksService.removeAll();
    }
  }

  onShareClick(){
    const fragment = this.generateFragment();
    if(fragment){
      const baseUrl = window.location.href.split("#")[0];
      const url = baseUrl +'#'+fragment;
      this.linkCopied = true;
      this.setClipboard(url).then(()=>{
        setTimeout(()=>{
          this.linkCopied = false;
        },3000)
      });
    }
  }

  override ngOnInit(): void {
    super.ngOnInit();
    const fragment = this.router.parseUrl(this.router.url).fragment;
    this.loadFromFragment(fragment);
  }

  loadFromFragment(fragment: string | null) {
    if (fragment) {
      const [key, value] = fragment.split('=');
      if (key === 'bookmarks') {
        this.bookmarksService.set(Bookmarks.fromJson(value));
      }
    }
  }

  generateFragment(){
    if(this.bookmarksService.extractIds().length){
      return `bookmarks=${this.bookmarks.toJson()}`;
    }
    return "";
  }

  setClipboard(text: string) {
    const type = "text/plain";
    const blob = new Blob([text], {type});
    const data = [new ClipboardItem({[type]: blob})];
    return navigator.clipboard.write(data);
  }


  setDisplay(display:string){
    this.displayAll = false;
    this.displayActivities = false;
    this.displayAccommodations = false;
    this.displayRestaurants = false;
    this.displayStays = false;
    this.displayServices = false;
    this.displayEvents = false;
    this.displayOthers = false;
    // @ts-ignore
    this[display] = true;
  }
}
